<template>
    <div v-if="!isBundle" class='ba-card-breadcrumb ba-card ba-jc-center'>
        <nav class='ba-breadcrumb'>
            <ol class='ba-breadcrumb-ol'>
                <li class='ba-breadcrumb-item ba-main-item'>
                    <router-link :to="{ name: 'Dashboard' }">
                        <builderall-icon code='sitebuilder'></builderall-icon>
                    </router-link>
                </li>
                <li class="ba-breadcrumb-item" v-for="(item, index) of items" :key="index" :class="{ 'ba-is-active': item.active }">
                    <a v-if="item.active" :class="{ 'ba-is-active': item.active }" @click.prevent>{{ $t(`ct-${item.title}`) }}</a>
                    <a @click.prevent="changePage(item)" v-else-if="item.params">{{ $t(`ct-${item.title}`)}}</a>
                    <router-link v-else :to="{ name: item.link, params: {} }">{{ $t(`${item.title}`) }}</router-link>
                </li>
            </ol>
        </nav>
    </div>
</template>

<script>
export default {
    data() {
        return {
            items: [],
            isBundle: false,
        };
    },
    watch: {
        $route: function (route) {
            this.items = route.meta.breadcrumb;
        }
    },
    methods: {
        changePage(item) {
            if (this.$route.params[item.params]) {
                this.$router.push({
                    name: item.link,
                    params: { id: this.$route.params[item.params] }
                });
            }
        }
    },
    created() {
        this.isBundle = localStorage.getItem('is_bundle') == 'exit-popup';
    },
    mounted() {
        this.items = this.$route.meta.breadcrumb;
    }
};
</script>

<style lang="scss" scoped>
    .ba-breadcrumb-item{
        a{
            cursor: pointer;
        }
    }
</style>


// WEBPACK FOOTER //
// src/components/general/Breadcrumbs.vue